// extracted by mini-css-extract-plugin
export default {"PDFContainer":"PDF_PDFContainer__yJ5yd","PDFDocument":"PDF_PDFDocument__n8ccn","PDFPage":"PDF_PDFPage__wDmZr","PDFPageOne":"PDF_PDFPageOne__TTkGv"};